export default __webpack_public_path__ + "static/media/live-icon.285bb817.webp";